import { useEffect, useState } from "react";
import styled from "styled-components";
import { images } from "../../assets/img";
import classes from "./FloatingButton.module.css";
import { NAIL_SHOP_INFO } from "../../utils/Const";

export default function FloatingButton() {
  const onClickIcon = () => {
    const phone = NAIL_SHOP_INFO.tel.replace(/[^\d]/g, "");
    const message = "Hello Blue Pearl Nails! I'd like to book an appointment.";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <img
      src={images.whatsappIcon}
      className={`${classes.imageIcon}`}
      alt="messenger-icon"
      onClick={onClickIcon}
    />
  );
}
